import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import { AuthService } from '../../services/auth-service/auth.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

  private isAuthorizing = false;

  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    request = request.clone({
      withCredentials: true,
    });

    if (
      !request.headers.has('Content-Type') &&
      !request.headers.has('upload')
    ) {
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
        },
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const authState = error.headers?.get('X-Auth-State');
        // if 401 during authorizing - remember and proceed
        if (error.status === 401 && authState === 'EXPIRED' && request.url.includes('api/authorize')) {
          this.isAuthorizing = true;
        }
        // if 401 for any other api call - redirect to the auth error page if not in authorizing process
        if (error.status === 401 && authState === 'EXPIRED' && !request.url.includes('api/authorize') && !this.isAuthorizing) {
          this.authService.redirectToAuthErrorPage();
          return EMPTY;
        }
        return throwError(() => error);
      }),
    );
  }
}
